import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ShareReservationState {
    buyShares: number;
    sellShares: number;
    sharePrice: number;
    openingFee: number;
    hasStartedBuyProcess: boolean;
}

const initialState: ShareReservationState = {
    buyShares: 0,
    sellShares: 0,
    sharePrice: 0,
    openingFee: 0,
    hasStartedBuyProcess: false,
};

const shareReservationSlice = createSlice({
    name: 'shareReservation',
    initialState: initialState,
    reducers: {
        setBuyShares: (state, action: PayloadAction<number>) => {
            return { ...state, buyShares: action.payload };
        },
        setSellShares: (state, action: PayloadAction<number>) => {
            return { ...state, sellShares: action.payload };
        },
        setSharePrice: (state, action: PayloadAction<number>) => {
            return { ...state, sharePrice: action.payload };
        },
        setOpeningFee: (state, action: PayloadAction<number>) => {
            return { ...state, openingFee: action.payload };
        },
        setShareReservationState: (
            state,
            action: PayloadAction<ShareReservationState>
        ) => {
            return { ...state, ...action.payload };
        },
        setHasStartedBuyProcess: (state, action: PayloadAction<boolean>) => {
            return { ...state, hasStartedBuyProcess: action.payload };
        },
        resetShareReservationState: () => {
            return initialState;
        },
    },
});

export const {
    setBuyShares,
    setSellShares,
    setShareReservationState,
    setHasStartedBuyProcess,
    resetShareReservationState,
} = shareReservationSlice.actions;
export const shareReservationReducer = shareReservationSlice.reducer;
export const selectShareReservation = (state: {
    shareReservation: ShareReservationState;
}) => state.shareReservation;
